import AppointmentsPage from './Appointments.page';

export default AppointmentsPage;
